export enum ReportType {
    /**
     * reports with tickets list
     */
    list = "list",

    /**
     * reports with total count
     */
    count = "count",

    /**
     * given and accepted
     */
    givenAndAccepted = "givenAndAccepted",

    /**
     * reports by the week
     */
    weekly = "weekly"
}